import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component,Inject,Input, OnInit, PLATFORM_ID} from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { FunctionService} from 'vhobjects-service/src/services';
@Component({
  selector: 'atw-text-discount-config',
  templateUrl: './text-discount-config.component.html',
  styleUrls: ['./text-discount-config.component.scss']
})
export class AtwTextDiscountConfig implements OnInit {
  @Input() data_tool: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() type_config : string; // xác định trang đang ở page hay preview
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {}; 
  styles_field = [
    {
      title: 'mau_nen_gradient',
      index: 1,
    },
  ];

  fonts = []; 
  isUsedClipPath: boolean = false;
  // Các dạng hình dạng
  clipPaths: any = [
    {
      id: 1,
      name: 'triangle',
      clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
    },
    {
      id: 2,
      name: 'diamond',
      clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)',
    },
    {
      id: 3,
      name: 'pentagon',
      clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)',
    },
    {
      id: 4,
      name: 'rabbet',
      clipPath: 'polygon(0% 15%, 15% 15%, 15% 0%, 85% 0%, 85% 15%, 100% 15%, 100% 85%, 85% 85%, 85% 100%, 15% 100%, 15% 85%, 0% 85%)',
    },
    {
      id: 5,
      name: 'left-arrow',
      clipPath: 'polygon(0% 50%, 50% 0%, 50% 25%, 100% 25%, 100% 75%, 50% 75%, 50% 100%)',
    },
    {
      id: 6,
      name: 'right-arrow',
      clipPath: 'polygon(0% 20%, 60% 20%, 60% 0%, 100% 50%, 60% 100%, 60% 80%, 0% 80%)',
    },
    {
      id: 7,
      name: 'left-point',
      clipPath: 'polygon(25% 0%, 100% 0%, 100% 100%, 25% 100%, 0% 50%)',
    },
    {
      id: 8,
      name: 'right-point',
      clipPath: 'polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)',
    },
    {
      id: 9,
      name: 'left-chevron',
      clipPath: 'polygon(100% 0%, 75% 50%, 100% 100%, 25% 100%, 0% 50%, 25% 0%)',
    },
    {
      id: 10,
      name: 'right-chevron',
      clipPath: 'polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%)',
    },
    {
      id: 11,
      name: 'message',
      clipPath: 'polygon(0% 0%, 100% 0%, 100% 75%, 75% 75%, 75% 100%, 50% 75%, 0% 75%)',
    },
    {
      id: 12,
      name: 'unknown_1',
      clipPath: 'polygon(0% 0%, 58% 0%, 100% 100%, 0% 100%)'
    },
    {
      id: 13,
      name: 'unknown_2',
      clipPath: 'polygon(0% 0%, 100% 0%, 58% 100%, 0% 100%)'
    },
    {
      id: 14,
      name: 'unknown_3',
      clipPath: 'polygon(0% 0%, 100% 0%, 80% 100%, 0% 100%)'
    },
    {
      id: 15,
      name: 'unknown_4',
      clipPath: 'polygon(0% 0%, 80% 0%, 100% 100%, 0% 100%)'
    },
    {
      id: 16,
      name: 'unknown_5',
      clipPath: 'polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%)'
    },
    {
      id: 17,
      name: 'unknown_6',
      clipPath: 'polygon(0% 0%, 100% 50%, 0% 100%, 25% 50%)'
    },
    {
      id: 18,
      name: 'star',
      clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)'
    },
    {
      id: 19,
      name: 'ellipse',
      clipPath: 'ellipse(25% 50% at 50% 50%)'
    },
    {
      id: 20,
      name: 'ellipse',
      clipPath: 'ellipse(50% 25% at 50% 50%)'
    },
    {
      id: 21,
      name: 'flag_discount',
      clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 50% 60%, 0% 100%)'
    }
  ];
  classUpdates = {
    "text-discount__content": { "clip-path": "none" }
  };
  configUpdates = {
    "box-shadow": {
      "is_box_shadow": false,
      "property_box_shadow": {
        "type": "outset",
        "h-offset": 1,
        "v-offset": 1,
        "blur": 1,
        "spread": 1,
        "color": "#ffffffff"
      }
    },
    "background-color": {
      "gradient_arr": [
        "rgb(0, 0, 255)",
        "rgb(255, 255, 0)"
      ],
      "background": "#8c52ff",
      "gradient_check": false,
      "value_range": 1,
      "gradient_type": "linear-gradient",
      "value_parameter": 100,
      "gradient_direction": ""
    },
    "discount_fold": {
      "display": "none",
      "width": "22px",
      "height": "20px",
      "left": "0px",
      "bottom": "-20px",
      "background_color": "#00a859",
      "clip_path": "polygon(0% 0%, 100% 0%, 100% 100%)"
    }
  };

  // private textFormatDiffer: KeyValueDiffer<string, any>;
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb, 
    private http: HttpClient,
    private vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
  }

  ngOnChanges() {
    if (this.config?.['box-shadow'].is_box_shadow) {
      this.class['text-discount__wrapper'].overflow = 'visible'
    } else {
      this.class['text-discount__wrapper'].overflow = 'hidden'
    }
  }

  ngOnInit(): void {
    for (const key in this.classUpdates) {
      if (!this.class.hasOwnProperty(key)) {
        this.class[key] = this.classUpdates[key];
      } else {
        for (const key2 in this.classUpdates[key]) {
          if (!this.class[key].hasOwnProperty(key2)) {
            this.class[key][key2] = this.classUpdates[key][key2];
          }
        }
      }
    }

    for (const key in this.configUpdates) {
      if (!this.config.hasOwnProperty(key)) {
        this.config[key] = this.configUpdates[key];
      } else {
        for (const key2 in this.configUpdates[key]) {
          if (!this.config[key].hasOwnProperty(key2)) {
            this.config[key][key2] = this.configUpdates[key][key2];
          }
        }
      }
    }
    
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
    ]) .subscribe(([fonts]:any)=>{
      this.fonts = fonts;
    })
    this.isUsedClipPath = this.class['text-discount__content']['clip-path'] && this.class['text-discount__content']['clip-path'] !== 'none';
  }

  /**
   * Xử lý hình dạng của tag giảm giá
   * @param item : trả về mẫu hình dạng được chọn
   * @param e : trả về element được active
   */
  chooseItem(item, event) {
    if (isPlatformBrowser(this.platformId)) {
      const variants_shape = this.class['text-discount__content'];
      this.class['text-discount__content']['clip-path'] = item.clipPath;
      variants_shape.name = item.name;
      this.updateClass();
    }
  }


  /**
   * Xử lý dạng hình
   */
  handleToggleBorderRadius() {
    this.class['text-discount__content']['border-top-left-radius'] = this.config['isCircle'] ? '100%' : '0px';
    this.class['text-discount__content']['border-top-right-radius'] = this.config['isCircle'] ? '100%' : '0px';
    this.class['text-discount__content']['border-bottom-left-radius'] = this.config['isCircle'] ? '100%' : '0px';
    this.class['text-discount__content']['border-bottom-right-radius'] = this.config['isCircle'] ? '100%' : '0px';
    this.updateObject();
  }

  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      this.config['background-color'].gradient_type = direction.type;
      this.config['background-color'].gradient_direction = direction.direction;
      this.class['text-discount__content']['background-image'] = this.config['background-color'].gradient_type + '(' + this.config['background-color'].gradient_direction + this.config['background-color'].gradient_arr.join(',') + ')'
      this.updateConfig();
      this.updateClass();
    }
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient = this.config['background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }

  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index) {
    if (this.config['background-color'][`gradient_arr`].length > 1) {
      this.config['background-color'][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb()
    }
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['text-discount__content']['background-image'] = "linear-gradient(" + this.config['background-color']['gradient_direction'] + this.config['background-color']['gradient_arr'] + ")";
    }
    else {
      this.class['text-discount__content']['background-image'] = "none";
    }
    this.updateObject();
  }

  /**
   * Hàm update class
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        
      })
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        
      })
  }

  /**
   * Hàm update config
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
        
      })
  }

  /**
   * Hàm update staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
      });
  }



  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại. 
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false
  };



  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event){
    if(event.width) this.class['text-discount']['width'] = event.width + 'px';
    if(event.height) this.class['text-discount']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }
}
